import * as React from "react";
import { useState } from "react";
import { XCircle } from "react-feather";
import { Portal } from "react-portal";
import { useAppContext } from "src/context/AppContext";
import { LanguageEnum } from "src/helpers/constants";
import {
  CloseButton,
  Container,
  LanguageButton,
  LanguageCodeText,
  LanguageSelectWrapper,
  LanguageTitle,
  LanguageWrapper,
  Modal,
  ModalTitle,
} from "./styled";

const LanguageSelect = () => {
  const { getLocation, selectedLanguage, setSelectedLanguage } =
    useAppContext();
  const [visible, setVisible] = useState(false);

  // Get location and supported languages
  const location = getLocation();
  const supportedLanguages = location?.supportedLanguages || ["en"];

  const size = window.screen.width > 600 ? "lg" : "sm";

  const handleClick = () => setVisible(!visible);

  const handleLanguageSelect = (language: string) => {
    setSelectedLanguage(language);
    setVisible(false);
  };

  return supportedLanguages ? (
    <>
      <LanguageSelectWrapper>
        <LanguageButton onClick={handleClick}>
          <LanguageCodeText
            $variant={selectedLanguage?.length > 2 ? "xs" : "sm"}
          >
            {selectedLanguage}
          </LanguageCodeText>
        </LanguageButton>
      </LanguageSelectWrapper>

      {visible && (
        <Portal>
          <Modal>
            <CloseButton onClick={handleClick}>
              <XCircle size={40} />
            </CloseButton>
            <ModalTitle $variant={size}>Select a Language</ModalTitle>
            <Container>
              {supportedLanguages.map((language) => (
                <LanguageWrapper key={language}>
                  <LanguageButton
                    $variant={size}
                    onClick={() => handleLanguageSelect(language)}
                  >
                    <LanguageCodeText as="span" $variant={size}>
                      {language}
                    </LanguageCodeText>
                  </LanguageButton>
                  <LanguageTitle $variant={size}>
                    {LanguageEnum[language]}
                  </LanguageTitle>
                </LanguageWrapper>
              ))}
            </Container>
          </Modal>
        </Portal>
      )}
    </>
  ) : null;
};

export default LanguageSelect;
